import React from "react";
import { useTranslation } from "react-i18next";
import { CODE_TABS } from "../landingData";
import { CODE_SNIPPETS } from "../landingCodeSnippets";

const LandingCodeDemo = () => {
  const { t } = useTranslation("common");
  const [activeTab, setActiveTab] = React.useState("full");

  return (
    <section className="code-demo" id="docs">
      <div className="section-header">
        <h2>{t("Two Modes, One Platform")}</h2>
        <p>{t("Choose how you want to work with your Odoo data")}</p>
      </div>
      <div className="code-card">
        <div className="code-tabs">
          {CODE_TABS.map(({ id, labelKey }) => (
            <button
              key={id}
              type="button"
              className={`tab ${activeTab === id ? "active" : ""}`}
              onClick={() => setActiveTab(id)}>
              {t(labelKey)}
            </button>
          ))}
          <div className="window-dots">
            <span style={{ background: "#FF5F57" }}></span>
            <span style={{ background: "#FEBC2E" }}></span>
            <span style={{ background: "#28C840" }}></span>
          </div>
        </div>
        <pre className="code-block">
          <code>{CODE_SNIPPETS[activeTab]}</code>
        </pre>
      </div>
    </section>
  );
};

export default LandingCodeDemo;
